var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-dialog",
        {
          attrs: {
            visible: _vm.innerVisible,
            title: _vm.title,
            width: "725px",
            "close-on-click-modal": false,
            "custom-class": "cooperation-branch-dialog"
          },
          on: {
            "update:visible": function($event) {
              _vm.innerVisible = $event
            },
            close: function($event) {
              _vm.innerVisible = false
            }
          }
        },
        [
          _c(
            "div",
            {
              staticClass: "app-main-inner-row row-grid",
              staticStyle: { padding: "0" }
            },
            [
              _c("cargo-ag-grid", {
                style: { width: "100%", height: "250px" },
                attrs: {
                  "show-side-bar": false,
                  "grid-options": _vm.gridOptions,
                  "column-defs": _vm.columnDefs,
                  "row-data": _vm.rowData
                }
              })
            ],
            1
          ),
          _c(
            "span",
            {
              staticStyle: { padding: "10px" },
              attrs: { slot: "footer" },
              slot: "footer"
            },
            [
              _c(
                "el-button",
                { attrs: { type: "primary" }, on: { click: _vm.handleClose } },
                [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_Close")))]
              )
            ],
            1
          )
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }